import FormField from "../form-field";
import Collapsible from "../components/collapsible";
import LocalizationsHelper from "../../../../lib/localizations-helper";
import DOMElement from "../../dom-element";
import Api from "../../../../lib/api";

export const PROMOCODE_ERROR_MESSAGES = [
    'Coupon not exists',
    'Coupon activation not allowed',
    'Coupon expired'
];

export const PROMOCODE_MIN_LENGTH = 4;
export const PROMOCODE_MAX_LENGTH = 20;

export function isValidPromocodeFormat(code) {
    if (typeof code !== 'string') {
        return false;
    }

    const trimmed = code.trim();

    return trimmed.length >= PROMOCODE_MIN_LENGTH && trimmed.length <= PROMOCODE_MAX_LENGTH;
}

export default class PromocodeField extends FormField {
    constructor(props = {}) {
        super(props);
    }

    _afterInit() {
        this.$collapsibleTrigger = this.$root.querySelector('[data-collapsible="trigger"]');
        this.$collapsibleRoot = this.$root.querySelector('[data-collapsible="collapsible"]');
        this.$promocodeInput = this.$root.querySelector('input[type="text"]');
        this.$acceptButton = this.$root.querySelector('.f-promocode-accept');

        this.collapsible = new Collapsible({
            $trigger: this.$collapsibleTrigger,
            $root: this.$collapsibleRoot
        });

        this.$promocodeInput.addEventListener('input', this._handleInput.bind(this));
        this.$acceptButton.addEventListener('click', this._handleAccept.bind(this));
    }

    setApplied() {
        this.$promocodeInput.disabled = true;
        this.$acceptButton.classList.add('-applied');
        this.$acceptButton.textContent = LocalizationsHelper.get('component.checkout.promocode.button.remove');
        this.controller.setValue({ code: this.$promocodeInput.value.trim(), applied: true });
    }

    setError(message) {
        if (!PROMOCODE_ERROR_MESSAGES.includes(message)) {
            return;
        }

        let errorMessage = '';

        switch (message) {
            case 'Coupon activation not allowed':
                errorMessage = `${LocalizationsHelper.get('component.checkout.promocode.error.notAllowed')} <a href="${Api.lmsUrl}/support" class="link" target="_blank">${LocalizationsHelper.get('component.checkout.promocode.error.supportManagerLink')}</a>`;
                break
            case 'Coupon expired':
                errorMessage = `${LocalizationsHelper.get('component.checkout.promocode.error.expired')}`;
                break;
            default:
                errorMessage = LocalizationsHelper.get('component.checkout.promocode.error.notValid');
                break;
        }

        const error = new DOMElement('p', {
            class: 'f-field-error f-field_error',
            attributes: {
                'data-form': 'field-error'
            },
            html: errorMessage
        });

        if (this.$error) {
            this.$error.replaceWith(error.getElement());
        } else {
            this.$root.appendChild(error.getElement());
        }

        this.$error = error.getElement();
    }

    _handleAccept() {
        if (this.$acceptButton.classList.contains('-applied')) {
            this.controller.setValue(null);
            this._setNotApplied();
            return;
        }

        if (!isValidPromocodeFormat(this.$promocodeInput.value)) {
            this._setStatus('invalid');
            return;
        }

        this._setStatus('neutral');
        this.controller.setValue({ code: this.$promocodeInput.value.trim(), applied: false});
    }

    /**
     * Prefills the input with a code obtained outside of user interaction (e.g. from the URL or a cookie)
     * and submits it through the same flow as a manual "apply" click.
     */
    applyCode(code) {
        if (!isValidPromocodeFormat(code)) {
            return;
        }

        const trimmedCode = code.trim();
        const currentValue = this.controller.getValue();

        if (currentValue && currentValue.applied && currentValue.code === trimmedCode) {
            return;
        }

        if (this.$acceptButton.classList.contains('-applied')) {
            this._setNotApplied();
        }

        this.$promocodeInput.value = trimmedCode;
        this.collapsible.expand();
        this._handleAccept();
    }

    _handleInput() {
        this._removeError();
        this._setStatus('neutral');
    }

    _setNotApplied() {
        this.$promocodeInput.removeAttribute('disabled');
        this.$acceptButton.classList.remove('-applied');
        this.$acceptButton.textContent = LocalizationsHelper.get('component.checkout.promocode.button.apply');
    }

    _removeError() {
        if (!this.$error) {
            return;
        }

        this.$error.remove();
        this.$error = null;
    }

    _refresh() {
        this.$promocodeInput.value = '';
    }
}